import {
  formatStockQuantity,
  perUnitQuantity,
} from '@/shared/lib/stock-quantity'

/** The source a variant draws from, as far as its usage text needs it. */
export interface VariantUsageSource {
  isDish: boolean
  /** The source's base unit as shown, for a plain source. */
  unit: string
  /** A dish source's parts, per sold unit of the dish. */
  parts?: Array<{ name: string; qty: number; unit: string }>
}

export type VariantUsageText =
  | { key: 'variant.usagePlain'; params: { qty: string; unit: string } }
  | { key: 'variant.usageDish'; params: { share: string; parts: string } }

/**
 * What one sale of a variant uses (CHG-2026-09-stock-usage-and-price-twins, D4, task 10.5): a
 * plain source × share ("0,5 Packung (2 Stk)"), or each part of a dish source × share, rounded to
 * 3 decimals exactly as the server books it.
 */
export function describeVariantUsage(
  share: number,
  source: VariantUsageSource,
): VariantUsageText {
  if (!source.isDish) {
    return {
      key: 'variant.usagePlain',
      params: { qty: formatStockQuantity(share), unit: source.unit },
    }
  }
  const parts = (source.parts ?? [])
    .map(
      (part) =>
        `${part.name} ${formatStockQuantity(perUnitQuantity(part.qty, share))} ${part.unit}`,
    )
    .join(', ')
  return {
    key: 'variant.usageDish',
    params: { share: formatStockQuantity(share), parts },
  }
}
